export function playerSlideInstanceKey(cacheNamespace: string | undefined, itemId: string): string {
  return `${cacheNamespace ?? "uncached"}-${itemId}`;
}

export function playlistHasDistinctNextItem(itemCount: number): boolean {
  return itemCount > 1;
}

export function playlistHasDisplayContent(currentItem: unknown, overlay: unknown): boolean {
  return Boolean(currentItem || overlay);
}

interface PlayerConfigurationIdentity {
  tv: { id: string };
  configurationVersion: number;
  cache: { namespace: string };
  playlist?: { id: string | null } | null;
}

export function isPlayerContentRefresh(
  next: PlayerConfigurationIdentity,
  previous?: PlayerConfigurationIdentity | null,
): boolean {
  return Boolean(
    previous &&
    next.tv.id === previous.tv.id &&
    next.configurationVersion === previous.configurationVersion &&
    next.cache.namespace === previous.cache.namespace &&
    next.playlist?.id === previous.playlist?.id,
  );
}

export function shuffledPlaylistItems<T extends { id: string }>(
  items: T[],
  previousItemId = "",
): T[] {
  const next = [...items];
  for (let index = next.length - 1; index > 0; index -= 1) {
    const target = Math.floor(Math.random() * (index + 1));
    [next[index], next[target]] = [next[target]!, next[index]!];
  }
  const first = next[0];
  const second = next[1];
  if (first && second && first.id === previousItemId) {
    next[0] = second;
    next[1] = first;
  }
  return next;
}
